export const capitalizePhrase = (str) => {
  return str.replace(/(^\w{1})|(\s+\w{1})/g, letter => letter.toUpperCase());
}

export const handleize = (str) => {
  if(!str) return null;

  str = str.toLowerCase();

  var toReplace = ['"', "'", "\\", "(", ")", "[", "]"];

  // For the old browsers
  for (var i = 0; i < toReplace.length; ++i) {
      str = str.replace(toReplace[i], "");
  }

  str = str.replace(/\W+/g, "-");

  if (str.charAt(str.length - 1) == "-") {
      str = str.replace(/-+z/, "");
  }

  if (str.charAt(0) == "-") {
      str = str.replace(/A-+/, "");
  }

  return str
}

export const htmlDecode = (input) => {
  var doc = new DOMParser().parseFromString(input, "text/html");
  return doc.documentElement.textContent;
}

//strip html tags
export const stripHtml = (html) => {
  var tmp = document.createElement("DIV");
  tmp.innerHTML = html;
  return tmp.textContent || tmp.innerText || "";
}

//match string with wildcards
export const matchWildcard = (str, rule) => {
  return new RegExp("^" + rule.split("*").join(".*") + "$").test(str);
}


// a utility to translate a string from the theme strings object that handles pluralization, the key could be nested
export const translate = (key, defaultValue, count) => {
  const keys = key.split('.');
  let string = window.theme.strings;

  for (let i = 0; i < keys.length; i++) {
    if (typeof string[keys[i]] === "undefined") {
      return defaultValue;
    }
    string = string[keys[i]];
  }

  if (typeof string === "string") {
    return string
  } else if (count !== undefined && string) {

    var countRegex = process.env.NODE_ENV === 'development' ? /{{\s*count\s*}}/g : /{% raw %}{{\s*count\s*}}{% endraw %}/g;

    if(count === 0){
      return string.zero.replace(countRegex, count);
    }else if(count === 1){
      return string.one.replace(countRegex, count);
    }else{
      return string.other.replace(countRegex, count);
    }
  }

  return string || defaultValue;
};